import { render, staticRenderFns } from "./SearchResponses.vue?vue&type=template&id=2242b8a6&scoped=true"
import script from "./SearchResponses.vue?vue&type=script&lang=js"
export * from "./SearchResponses.vue?vue&type=script&lang=js"
import style0 from "./SearchResponses.vue?vue&type=style&index=0&id=2242b8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2242b8a6",
  null
  
)

export default component.exports